"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FontWeightEnum = void 0;
var FontWeightEnum;
(function (FontWeightEnum) {
    FontWeightEnum[FontWeightEnum["Thin"] = 400] = "Thin";
    FontWeightEnum[FontWeightEnum["Medium"] = 500] = "Medium";
    FontWeightEnum[FontWeightEnum["SemiBold"] = 700] = "SemiBold";
    FontWeightEnum[FontWeightEnum["Bold"] = 900] = "Bold";
})(FontWeightEnum = exports.FontWeightEnum || (exports.FontWeightEnum = {}));
//# sourceMappingURL=font-weight-enum.js.map